import React from "react";
import bioAlignImage from "../../assets/images/bio_align.png";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import Meta from "../../Meta/Meta";
const ThankYou = () => {
  const navigate = useNavigate();
  return (
    <>
      <Meta slug={"thankyou"} />
      <section>
        <div className="container">
          <div className="w-[100%] py-[10rem] flex justify-center items-center flex-col gap-[1rem]">
            <h1 className="font-primary font-medium text-[5rem] text-milkgreen">
              Thank You
            </h1>
            <p className="font-primary font-medium text-[1.5rem] text-lightgray text-center">
              Thank you for submitting the form. Our team shall get back to you
              shorty.
            </p>
            <p className="font-primary font-bold text-[1.5rem] text-lightgray text-center">
              We look forward to meeting you soon
            </p>
            <img
              src={bioAlignImage}
              alt="bio align"
              className="w-[100px] h-auto mt-[1rem]"
            />
            <Button
              type="primary"
              size="large"
              className="font-primary font-medium text-[1.5rem] text-white text-center"
              style={{
                marginTop: "1rem",
                backgroundColor: "#268F81",
              }}
              onClick={() => navigate("/")}
            >
              Home
            </Button>
          </div>
        </div>
      </section>
    </>
  );
};

export default ThankYou;
